import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import { saveAs } from 'file-saver';


class BusinessPlans extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getBusinessPlans();
    };



    getBusinessPlans = async()=>{
        var response = await Api.GetRequest({}, 'entrepreneurship-developement/business-plans');
        if(response.status == 200){
            this.setState({'business_plans' : response.business_plans});
        }
        else{
            toast.error("Something went wrong. Please try again later.");
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'business_plans' : []
        };
    }


    downloadPdf = async(plan)=>{
       saveAs(process.env.REACT_APP_SERVER + plan.pdf, plan.title+'.pdf');
    }
    
    

    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Business Plans</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            {this.state.business_plans.map((business_plan)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;">
                                                    <img src={process.env.REACT_APP_SERVER + business_plan.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a style={{'color' : '#000000'}} href="javascript:;">{business_plan.title}</a>
                                                </h5>
                                                <a href={process.env.REACT_APP_SERVER + business_plan.pdf} target="__blank"><button className="btn btn_theme btn_md mt-3 py-1">Download</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(BusinessPlans)